document.addEventListener('DOMContentLoaded', function() {
    var el = document.body;
    var header = document.getElementById('header');

    function bindResourceSelector() {
        var select = document.querySelector('#cat');
        if(!select)
            return;

        select.onchange = function(){
            if(this.options[this.selectedIndex].value == 0){

                jQuery('.resources-item').show();
            } else {
                jQuery('.resources-item').hide();
                jQuery('.'+this.options[this.selectedIndex].value).show();

            }
        }
    }


    function bindNavbarToggler() {
        console.log('bindNavbarToggler');
        if (!header) {
            return;
        }
        console.log('header', header);
        var navbarToggler = header.querySelector('.navbar-toggler');
        if (!navbarToggler) {
            return;
        }
        console.log('navbarToggler', navbarToggler);
        navbarToggler.addEventListener('click', function(e) {
            e.preventDefault();
            console.log('clicked');
            if (header.classList.contains('navbar-shown')) {
                header.classList.remove('navbar-shown');
                dropdownsClose(header);

            } else {
                header.classList.add('navbar-shown');
            }
        });
    }

    function initializeSliders() {
        var sliders = Array.from(document.getElementsByClassName('hero-slider'));
        if (!sliders || sliders.length < 1) {
            return;
        }
        var cellSelector = '.slide';
        sliders.forEach(function(slider) {
            var slides = Array.from(slider.querySelectorAll(cellSelector));
            if (!slides || slides.length < 2) {
                return;
            }
            new Flickity(slider, {
                wrapAround: true,
                prevNextButtons: false,
                cellSelector: cellSelector,
            })
        })
    }

    function initializeAccordions() {
        var accordions = Array.from(document.querySelectorAll('.accordion-item'));
        var expandedClass = 'expanded';
        if (!accordions || accordions.length === 0) {
            return;
        }
        var hash = window.location.hash;
        if (hash) {
            accordions.forEach(function(accordion) {
                var suitableAccordion = accordion.querySelector(hash);
                if (!suitableAccordion) {
                    return;
                }
                accordion.classList.add(expandedClass);
            });
        }
        accordions.forEach(function(accordion) {
            var heading = accordion.querySelector('.accordion-heading-wrapper');
            if (!heading) {
                return;
            }
            heading.addEventListener('click', function(event) {
                event.preventDefault();
                if (accordion.classList.contains(expandedClass)) {
                    accordion.classList.remove(expandedClass);
                    window.location.hash = '';
                } else {
                    accordion.classList.add(expandedClass);
                }
            });
        });
    }

    function initializeMasonry() {
        var msnry = new Masonry( '.grid', {
            itemSelector: '.grid-item',
            percentPosition: true,
        });

        window.addEventListener('load', function() {
            msnry.layout();
        });
    }

    function initializeNavDropdowns() {
        var dropdowns = Array.from(document.querySelectorAll('.navbar-nav .nav-item.dropdown'));
        if (!dropdowns || dropdowns.length < 1) {
            return;
        }
        dropdowns.forEach(function(dropdown) {
            dropdown.addEventListener('mouseenter', function(event) {
                if (window.innerWidth > 1199) {
                    dropdownShow(this.classList);
                }
            });
            dropdown.addEventListener('mouseleave', function(event) {
                if (window.innerWidth > 1199) {
                    dropdownHide(this.classList);
                }
            });
            dropdown.addEventListener('mousedown', function(event) {
                if (event.which !== 1) {
                    return;
                }
                dropdownEvent(event, this.classList);
            });
            dropdown.addEventListener('touchend', function(event) {
                dropdownEvent(event, this.classList);
            });
        })
    }
    function dropdownHide(classList) {
        classList.remove('open');
    }

    function dropdownShow(classList) {
        classList.add('open');
    }

    function dropdownEvent(event, classList) {
        if (event.target.href.indexOf('#') + 1 === event.target.href.length) {
            event.preventDefault();
            if (classList.contains('open')) {
                classList.remove('open');
            } else {
                classList.add('open');
            }
        }
    }

    function dropdownsClose(parentEl) {
        var dropdowns = Array.from(parentEl.querySelectorAll('.navbar-nav .nav-item.dropdown'));
        if (!dropdowns || dropdowns.length < 1) {
            return;
        }
        dropdowns.forEach(function(dropdown) {
            dropdownHide(dropdown.classList);
        });
    }

    //WP_BOOTSTRAP_NAVWALKER FIX for top level menu items links:
    jQuery('.dropdown-toggle').click(function() { 
        if (jQuery(window).width() > 768) if (jQuery(this).next('.dropdown-menu').is(':visible')) window.location = jQuery(this).attr('href'); 
    });

    function bindEvents() {
        bindNavbarToggler();
        bindResourceSelector();
    }


    function init() {
        bindEvents();
        initializeSliders();
        initializeAccordions();
        initializeMasonry();
        initializeNavDropdowns();
    }
    init();
});
